import { useCallback } from 'react';

import { useAuthStore } from '@/shared/store/auth.store';

import { ApiRefreshResponse } from '../generated/data-contracts';
import { GtwAuth } from '../generated/GtwAuth';
import { ApiBaseError, HttpResponse } from '../generated/http-client';
import { getApiConfig } from '../helpers/getApiConfig';

let tokenRefreshRequestPromise: Promise<HttpResponse<ApiRefreshResponse, ApiBaseError>> | null =
  null;

export const useExpiredNewAuthTokenHandle = ({ logout }: { logout: () => Promise<void> }) => {
  const setAccessToken = useAuthStore((s) => s.setAccessToken);

  const onNewAuthTokenExpired = useCallback(async () => {
    const refreshAccessToken = new GtwAuth(getApiConfig(undefined, { logout })).authRefresh;

    if (!tokenRefreshRequestPromise) {
      tokenRefreshRequestPromise = refreshAccessToken({});
    }

    const response = await tokenRefreshRequestPromise;
    tokenRefreshRequestPromise = null;

    if (response.error || !response.data) {
      return null;
    }

    const accessToken = response.data.accessToken;

    setAccessToken(accessToken);

    return accessToken;
  }, [logout]);

  return { onNewAuthTokenExpired };
};
